// Sprint Points fields are system-created (userCreated=false) but have no native
// Clickhouse column; the API only resolves them by fieldId.
const POINTS_FIELD_NAMES = new Set([
    'pointslinear',
    'pointsfibonacci',
    'pointsexponential',
    'pointscustom'
]);
export const isSentAsCustomField = (field)=>{
    var _ref;
    return Boolean(field === null || field === void 0 ? void 0 : field.userCreated) || POINTS_FIELD_NAMES.has(((_ref = field === null || field === void 0 ? void 0 : field.fieldName) !== null && _ref !== void 0 ? _ref : '').toLowerCase());
};
